import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=9a154d4c&scoped=true"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=9a154d4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a154d4c",
  null
  
)

export default component.exports